import { useApi } from '@omnipresentgroup/api';
import type { GetCompanyAPIResponse } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

type Selector<T> = (data: GetCompanyAPIResponse) => T;

export const useCompany = <T = GetCompanyAPIResponse>({
  id,
  enabled,
  select,
}: {
  id?: string;
  enabled?: boolean;
  select?: Selector<T>;
}) => {
  const { GET } = useApi();
  const query = useQuery({
    queryKey: [API_PATH, id],
    queryFn: id
      ? () => GET<GetCompanyAPIResponse>(`${API_BASE}/${API_PATH}/${id}`)
      : () => Promise.reject(new Error('Invalid id to fetch a company')),
    enabled: enabled && !!id,
    select,
    staleTime: Number.POSITIVE_INFINITY,
  });

  return query;
};
